import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useDebouncedWindowSize } from '../../hooks/useDebouncedWindowSize';
const PERCENT_OF_SCREEN_VIDEO_SCALE = 92;
export const IntroVideo = () => {
    const [isVideoMetadataLoaded, setIsVideoMetadataLoaded] = useState(false);
    const videoRef = useRef(null);
    const { windowWidth, windowHeight } = useDebouncedWindowSize();
    useEffect(() => {
        const videoElement = videoRef.current;
        const handleLoadedMetadata = () => {
            setIsVideoMetadataLoaded(true);
        };
        if (videoElement) {
            videoElement.addEventListener('loadedmetadata', handleLoadedMetadata);
        }
        return () => {
            if (videoElement) {
                videoElement.removeEventListener('loadedmetadata', handleLoadedMetadata);
            }
        };
    }, []);
    const isLandscape = windowWidth > windowHeight;
    /**
     * Adjust rendering behavior to only show the video once its metadata (dimensions) are known,
     * to avoid any flickering "empty container" or stylying weirdness.
     */
    const style = useMemo(() => isVideoMetadataLoaded
        ? css(css `
              border-radius: 20px;
              border: 2px solid black;
              filter: drop-shadow(6px 6px 0 rgba(0, 0, 0, 0.2));
            `, 
        // adjust scaling of video based on whether the window appears to be in landscape or portrait orientation
        isLandscape
            ? css `
                  max-height: ${PERCENT_OF_SCREEN_VIDEO_SCALE}vh;
                  width: auto;
                `
            : css `
                  max-width: ${PERCENT_OF_SCREEN_VIDEO_SCALE}vw;
                  height: auto;
                `)
        : css `
            visibility: hidden;
          `, [isVideoMetadataLoaded, isLandscape]);
    return (_jsx("video", { ref: videoRef, autoPlay: true, muted: true, loop: true, playsInline: true, width: 512, height: 512, css: style, children: _jsx("source", { src: 'https://www.triplejack.com/assets/video/triplejack-square-intro-062923.mp4', type: 'video/mp4' }) }));
};
